(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["field-list-modal"]) return;
  try {
    
  (function () {
    var modal = document.querySelector('[data-field-list-modal]');
    if (!modal) return;

    var success = modal.querySelector('[data-field-modal-success]');
    var error = modal.querySelector('[data-field-modal-error]');
    var dismissUntilKey = 'rt-field-list-modal-dismissed-until-v1';
    var enrolledKey = 'rt-field-list-modal-enrolled-v1';
    var sessionKey = 'rt-field-list-modal-shown-v1';
    var lastFocus = null;
    var opened = false;

    function readStorage(storage, key) {
      try { return storage.getItem(key); } catch (storageError) { return null; }
    }

    function writeStorage(storage, key, value) {
      try { storage.setItem(key, value); } catch (storageError) { return; }
    }

    function focusableElements() {
      return Array.prototype.slice.call(modal.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href]'));
    }

    function openModal() {
      if (opened) return;
      opened = true;
      lastFocus = document.activeElement;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      writeStorage(window.sessionStorage, sessionKey, '1');
      window.requestAnimationFrame(function () {
        modal.classList.add('is-open');
        var firstFocus = modal.querySelector('[data-field-modal-success]') || modal.querySelector('input') || modal.querySelector('.rt-field-modal__close');
        if (firstFocus) firstFocus.focus();
      });
    }

    function closeModal() {
      if (!opened) return;
      opened = false;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      writeStorage(window.localStorage, dismissUntilKey, String(Date.now() + (14 * 24 * 60 * 60 * 1000)));
      window.setTimeout(function () {
        modal.hidden = true;
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      }, 190);
    }

    function eligibleForPrompt() {
      if (success || error) return true;
      if (readStorage(window.localStorage, enrolledKey) === '1') return false;
      if (readStorage(window.sessionStorage, sessionKey) === '1') return false;
      var dismissedUntil = Number(readStorage(window.localStorage, dismissUntilKey) || 0);
      return Date.now() > dismissedUntil;
    }

    if (success) {
      writeStorage(window.localStorage, enrolledKey, '1');
      openModal();
    } else if (error) {
      openModal();
    } else if (eligibleForPrompt()) {
      var earliestOpen = Date.now() + 3500;
      var scrollThreshold = Math.min(520, Math.max(220, document.documentElement.scrollHeight * 0.08));
      var onScroll = function () {
        if (window.scrollY < scrollThreshold || Date.now() < earliestOpen) return;
        window.removeEventListener('scroll', onScroll);
        openModal();
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.setTimeout(onScroll, 3600);
    }

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-field-modal-dismiss]')) closeModal();
    });

    document.addEventListener('keydown', function (event) {
      if (!opened) return;
      if (event.key === 'Escape') {
        closeModal();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = focusableElements();
      if (focusable.length === 0) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
